import { render } from "./ContactInfo.vue?vue&type=template&id=48f32806&scoped=true&bindings={\"modelValue\":\"props\",\"validator\":\"props\",\"allContacts\":\"props\",\"id\":\"props\",\"value\":\"setup\",\"previousContact\":\"setup\",\"roles\":\"setup\",\"$val\":\"options\",\"previousContactRole\":\"options\",\"canDelete\":\"options\",\"onInput\":\"options\",\"onDelete\":\"options\"}"
import script from "./ContactInfo.vue?vue&type=script&lang=js"
export * from "./ContactInfo.vue?vue&type=script&lang=js"

import "./ContactInfo.vue?vue&type=style&index=0&id=48f32806&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-48f32806"

export default script